export default __webpack_public_path__ + "static/media/gplay.6e2839af.svg";